export enum UserContexts {
  Individual,
  School,
}
